import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
// eslint-disable-next-line import/no-cycle
import { useEcoHospitalStore } from '~store/ecohospital/ecohospitalModule';
import { GoskluchSignType } from '~store/ecohospital/types';
import GoskluchSignDialog from '@/components/GoskluchSignDialog.vue';

const UKEP: GoskluchSignType = 1;
const UNEP: GoskluchSignType = 2;

type SignAnswer = 'yes' | 'no' | 'unknown' | 'ukep' | 'unep';

export const useGoskluchSign = () => {
  const $q = useQuasar();
  const ecoStore = useEcoHospitalStore();

  let asking = false;

  const openChooseDialog = (unepAllowed: boolean) => new Promise<GoskluchSignType | null>(
    (resolve) => {
      $q.dialog({
        component: GoskluchSignDialog,
        componentProps: { mode: 'choose', unepAllowed },
      })
        .onOk((answer: SignAnswer) => resolve(answer === 'yes' || answer === 'ukep' ? UKEP : UNEP))
        .onCancel(() => resolve(null));
    },
  );

  // Соглашение подписано — даём выбрать УКЭП / УНЭП.
  // Нет — спрашиваем про УКЭП; «Нет» / «Не знаю» — пробуем УНЭП (бэк проверит соглашение).
  // null — пользователь закрыл диалог.
  const askSignType = async (): Promise<GoskluchSignType | null> => {
    if (asking) return null;
    asking = true;
    try {
      let unepAllowed = false;
      try {
        unepAllowed = await ecoStore.isUnepAllowed();
      } catch (error) {
        console.error('Ошибка при проверке доступности УНЭП:', error);
      }
      return await openChooseDialog(unepAllowed);
    } finally {
      asking = false;
    }
  };

  const showAgreementRequired = () => {
    $q.dialog({
      component: GoskluchSignDialog,
      componentProps: { mode: 'agreement' },
    });
  };

  const notifySignFailed = () => {
    $q.notify({
      type: 'warning',
      message: 'Не удалось подписать документ',
      position: 'top',
      timeout: 5000,
    });
  };

  // true — документ ушёл на подписание
  const signDocument = async (id_document: number, type_sign: GoskluchSignType) => {
    try {
      const { ok } = await ecoStore.signGoskluchDocument(id_document, type_sign);
      if (ok) {
        $q.notify({
          type: 'positive',
          message: 'Документ поставлен в очередь на подписание',
          caption: 'Пожалуйста, откройте приложение ГОСКЛЮЧ на телефоне',
          position: 'top',
          timeout: 5000,
          multiLine: true,
        });
        return true;
      }
      // УНЭП без действующего соглашения бэк отклоняет
      if (type_sign === UNEP) {
        showAgreementRequired();
      } else {
        notifySignFailed();
      }
    } catch (error) {
      console.error('Ошибка при подписании ГОСКЛЮЧОМ:', error);
      notifySignFailed();
    }
    return false;
  };

  return {
    askSignType,
    signDocument,
  };
};
